import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { User, Lock, Envelope } from '@phosphor-icons/react';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await register(email, password, name);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="auth-container px-4">
      <div className="w-full max-w-md p-6 sm:p-8 border border-border bg-card rounded-sm">
        <div className="mb-8">
          <h1 className="text-4xl tracking-tight font-bold mb-2">Create Account</h1>
          <p className="text-muted-foreground text-sm">GET STARTED WITH YOUR BUSINESS DASHBOARD</p>
        </div>

        {error && (
          <div
            data-testid="register-error"
            className="mb-6 p-4 bg-destructive/10 border border-destructive text-destructive text-sm rounded-sm"
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">
              Full Name
            </Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2" size={18} weight="regular" />
              <Input
                id="name"
                data-testid="register-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="pl-10 h-12 rounded-sm"
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="email" className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">
              Email Address
            </Label>
            <div className="relative">
              <Envelope className="absolute left-3 top-1/2 -translate-y-1/2" size={18} weight="regular" />
              <Input
                id="email"
                data-testid="register-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 h-12 rounded-sm"
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">
              Password
            </Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2" size={18} weight="regular" />
              <Input
                id="password"
                data-testid="register-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 h-12 rounded-sm"
                required
              />
            </div>
          </div>

          <Button
            data-testid="register-submit-button"
            type="submit"
            className="w-full h-12 rounded-sm font-semibold tracking-tight"
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Create Account'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm">
          <span className="text-muted-foreground">Already have an account? </span>
          <Link
            to="/login"
            data-testid="navigate-to-login"
            className="text-accent hover:text-accent/90 font-medium"
          >
            Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
